import React from "react";
import TerminalList from "../../components/TerminalList/TerminalList";

const TerminalListPage = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a href="/admin">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">Terminal Entries</li>
              </ol>
            </div>
            <h4 className="page-title">Terminal Entries</h4>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <TerminalList />
        </div>
      </div>
    </div>
  );
};

export default TerminalListPage;
